import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';

import StatusError from '@telus-uds/palette-allium/build/web/icons/StatusError';
import Label from './common/label';
import { CONSTANT } from '../../utils/constant';

const Cpms = ({ labels, errors, touched, role }) => {
  const {
    KEYS: {
      ROLES: { SALES_SUPPORT }
    }
  } = CONSTANT;

  const getFieldLabel = label =>
    role === SALES_SUPPORT ? label.replace('*', '') : label;

  return (
    <>
      <Label labelName={getFieldLabel(labels.CPMS_ID)} />
      <div
        style={{ position: 'relative' }}
        className={`input-container ${
          errors.cpmsId && touched.cpmsId ? 'error' : ''
        }`}
      >
        <Field
          placeholder={labels.PLACEHOLDER_CPMS_ID}
          className="select-style"
          name="cpmsId"
          type="text"
        />
        <>
          <div className="error_messages">
            <span className="frg-body-font-14px">{errors.cpmsId}</span>
          </div>
          <div id="username_error_icon" className="error_messages_icon">
            <StatusError size={16} color="#C12335" aria-hidden="true" />
          </div>
        </>
      </div>
    </>
  );
};

Cpms.propTypes = {
  labels: PropTypes.isRequired,
  errors: PropTypes.isRequired,
  touched: PropTypes.func.isRequired,
  role: PropTypes.string.isRequired
};

export default Cpms;
